<template>
  <iframe class="pdf-container" ref="pdf" :src="src"></iframe>
</template>

<script>
import { PDFDocument } from 'pdf-lib';

async function mergePDFs(pdfs) {
  // 创建一个新的 PDF 文档
  const mergedPdf = await PDFDocument.create();

  for (const url of pdfs) {
    console.log('url', url);
    const response = await fetch(url);

    if (!response.ok) {
      console.log(`无法下载 PDF: ${url}`);
      continue;
    }

    const pdfBytes = await response.arrayBuffer(); // 获取 PDF 数据
    const pdfDoc = await PDFDocument.load(pdfBytes); // 加载 PDF 文档

    // 复制所有页面
    const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
    pages.forEach(page => mergedPdf.addPage(page));
  }

  // 生成合并后的 PDF 字节流
  const mergedPdfBytes = await mergedPdf.save();

  // 创建下载链接
  const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}

export default {
  name: 'printPDF',
  data() {
    return {
      src: ''
    };
  },
  methods: {
    async init(source, cb) {
      const pdf = this.$refs.pdf;

      const fn = () =>
        this.$nextTick(() => {
          if (pdf.contentWindow.print) {
            pdf.contentWindow.print();
            cb && cb();
            pdf.removeEventListener('load', fn);
          } else {
            this.$message.error('浏览器不支持打印，请升级浏览器');
          }
        });

      pdf.addEventListener('load', fn);

      this.src = await mergePDFs(source);
    }
  }
};
</script>

<style scoped lang="scss">
.pdf-container {
  display: none;
  width: 100%;
  height: 100vh;
}
</style>
